/*
  Rescuevation: ATEX-Kollektion, Bewegungsebene (rescu-atx-*).
  Additiv: Ohne dieses Skript ist jede Seite fertig und vollständig
  sichtbar. Sobald ein Bereich mit [data-ratx-an] ins Bild kommt, bekommt
  er einmalig die Klasse .ratx-los; die Keyframes in rescu-atx.css laufen
  dann darüber. Zahlen mit [data-ratx-zahl] zählen dabei hoch und enden
  wieder exakt auf ihrem Originaltext. Bei prefers-reduced-motion passiert
  nichts.
*/
(function () {
  if (window.__ratxBewegung) return;
  window.__ratxBewegung = true;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var zaehlen = function (el) {
    var original = el.textContent;
    // Nur Werte, die mit der Zahl beginnen ("432 m", "80 h"); "IP67" bleibt stehen.
    var treffer = original.match(/^(\s*)(\d{1,3}(?:\.\d{3})*|\d+)(.*)$/);
    if (!treffer) return;
    var ziel = parseInt(treffer[2].replace(/\./g, ''), 10);
    if (!ziel || ziel < 10) return;
    var dauer = 1300;
    var start = null;
    var format = function (n) { return n.toLocaleString('de-DE'); };
    var verzoegerung = parseInt(el.getAttribute('data-ratx-zahl') || '0', 10) || 0;
    el.textContent = treffer[1] + '0' + treffer[3];
    var schritt = function (t) {
      if (start === null) start = t;
      var p = Math.min(1, (t - start) / dauer);
      var e = 1 - Math.pow(1 - p, 3);
      if (p < 1) {
        el.textContent = treffer[1] + format(Math.round(ziel * e)) + treffer[3];
        window.requestAnimationFrame(schritt);
      } else {
        el.textContent = original;
      }
    };
    window.setTimeout(function () { window.requestAnimationFrame(schritt); }, verzoegerung);
  };

  var beobachter = new IntersectionObserver(function (eintraege) {
    eintraege.forEach(function (eintrag) {
      if (!eintrag.isIntersecting) return;
      var el = eintrag.target;
      beobachter.unobserve(el);
      el.classList.add('ratx-los');
      Array.prototype.forEach.call(el.querySelectorAll('[data-ratx-zahl]'), zaehlen);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });

  var start = function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ratx-an]'), function (el) {
      beobachter.observe(el);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('shopify:section:load', start);
})();
